import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import '../../styles/error.scss';

const ErrorPage = (props) => {
  return (
    <div className='error-container'>
      <div className='error-header'>
        <div className='error-subheader'>
          <FormattedMessage id='Error' /> {props.code}
        </div>
        <span dangerouslySetInnerHTML={{ __html: props.text }} />
      </div>
      <img src={props.img} />
      <Link to='/' className='button button-red'>
        <FormattedMessage id='Back to main page' />
      </Link>
    </div>
  );
};

export default ErrorPage;
